import React, { useState } from 'react';
import { queryClient } from '../../utils/queryClient';
import { Initials } from '../ui';
import { ContactIcon, CrownIcon, EmailIcon } from '../../icons';
import {
  useDeleteDrivers,
  useSetPrimaryDriver,
  useUnAssignDrivers,
} from '../../hooks/react-query/useDrivers';
import ActionItems from './actionItems';
import { QUERY_KEYS } from '../../config/constants';

const { DRIVERS ,ASSIGN_DRIVERS} = QUERY_KEYS;

const AsignedDriversCard = ({ driverDetails, plateNumber,carName }) => {
  const { firstName, lastName, email, phone, id, isPrimary } = driverDetails;
  const [openFirstModal, setOpenFirstModal] = useState(false);
  const [openSecondModal, setOpenSecondModal] = useState(false);
  const [openThirdModal, setOpenThirdModal] = useState(false);

  const { mutate: deleteDriver, isLoading: isDeleteDriverLoading } =
    useDeleteDrivers();
  const { mutate: unAssignDriver, isLoading: isUnAssignDriverLoading } =
    useUnAssignDrivers();
  const { mutate: setPrimaryDriver, isLoading: isPrimaryLoading } =
    useSetPrimaryDriver();

  const isPrimaryDriver = isPrimary === 1;

  const handleClickAction = (actionType) => {
    switch (actionType) {
      case 'setPrimaryDriver':
        setPrimaryDriver(
          { userId: id, plateno: plateNumber },
          {
            onSuccess: () => {
              queryClient.invalidateQueries({
                queryKey: [DRIVERS, plateNumber],
              });

              setOpenFirstModal(false);
            },
          }
        );
        break;
      case 'unAssignDriver':
        unAssignDriver(
          { id, plateno: plateNumber },
          {
            onSuccess: () => {
              queryClient.invalidateQueries({
                queryKey: [DRIVERS, plateNumber],
              });
              queryClient.invalidateQueries({
                queryKey:[ASSIGN_DRIVERS, plateNumber],
              });
              queryClient.invalidateQueries({ 
                queryKey: ['driversListPerCar', plateNumber]
              });
              setOpenSecondModal(false);
            },
          }
        );
        break;
      case 'deleteDriver':
        deleteDriver(id, plateNumber, {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [DRIVERS, plateNumber]
            });
            queryClient.invalidateQueries({ 
              queryKey: ['driversListPerCar', plateNumber]
            });
            setOpenThirdModal(false);
          },
        });
        break;
      default:
        break;
    }
  };

  return (
    <div
      className="flex flex-col min-w-[390px] min-h-[190px] justify-between rounded-xl shadow-[0_2px_6px_0px_rgba(99, 99, 99, 0.20)] p-3"
      style={{ boxShadow: '0px 2px 6px 0px rgba(99, 99, 99, 0.20)' }}
    >
      <div className="flex items-center justify-between ">
        <div className="flex items-center gap-x-3.5">
          <Initials firstName={firstName} lastName={lastName} />
          <h6>
            {firstName} {lastName}
          </h6>
        </div>
        {isPrimaryDriver ? (
          <CrownIcon />
        ) : (
          <ActionItems
            firstName={firstName}
            lastName={lastName}
            plateNumber={plateNumber}
            isLoading={
              isDeleteDriverLoading ||
              isUnAssignDriverLoading ||
              isPrimaryLoading
            }
            carName={carName}
            handleClickAction={handleClickAction}
            openFirstModal={openFirstModal}
            openSecondModal={openSecondModal}
            openThirdModal={openThirdModal}
            setOpenFirstModal={(value) => setOpenFirstModal(value)}
            setOpenSecondModal={(value) => setOpenSecondModal(value)}
            setOpenThirdModal={(value) => setOpenThirdModal(value)}
          />
        )}
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2">
          <EmailIcon />
          <span className="text-body">{email}</span>
        </div>
        <div className="flex gap-2">
          <ContactIcon />
          <span className="text-body">{phone}</span>
        </div>
      </div>
    </div>
  );
};

export default AsignedDriversCard;
